import styled from 'styled-components';
import { Button, StyledTextInput } from 'bench-internal-theme';
import { colors } from 'bench-style-constants';

export const PageControlsLayout = styled.div`
  align-items: center;
  display: grid;
  grid-column-gap: 8px;
  grid-template-columns: max-content 180px 252px 100px repeat(3, max-content);
  justify-content: flex-start;
  padding: 16px 32px;
  white-space: nowrap;
`;

export const SearchForm = styled.form`
  display: grid;
  grid-template-columns: 215px 36px;
`;

export const SearchInput = styled(StyledTextInput)`
  border-right: none;
  border-radius: 2px 0 0 2px;
`;

export const SearchInputWrapper = styled.div`
  position: relative;
`;

export const ClearButton = styled.button`
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  padding: 2px 2px;
  color: #fff;
  background-color: ${colors.dust};
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;

  &:hover,
  :focus {
    background-color: ${colors.cloud};
    cursor: pointer;
  }

  &:focus-visible {
    outline: none;
    box-shadow: 0 0 0 3px ${colors.water};
  }

  & svg {
    cursor: pointer;
  }
`;

export const SearchButton = styled(Button)`
  border: none;
  border-radius: 0 2px 2px 0;
  background-position: 9px 50%;
`;
